import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const PHP = () => {
  return (
    <StartInterviewLayout type="php"/>
  )
}

export default PHP;